export function LinearProgress() {
  return (
    <div
      aria-label="Loading"
      aria-valuemax={100}
      aria-valuemin={0}
      className="relative h-1 w-full overflow-hidden bg-legacy-neutrals-fog"
      role="progressbar"
    >
      <div className="absolute inset-y-0 left-0 w-1/3 animate-loading-overlay-slide bg-legacy-orange-base" />
    </div>
  );
}
